import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { Reflection } from "../../helpers/reflection";
import { type IPaginationPage, PagePaginationMappings, PaginationMappings } from "./comp-pagination.models";

//Load styles
require("./comp-pagination.scss");

@autoinject()
export class CompPagination {

	private paginationMappings: PaginationMappings<any>;

	@bindable
	public theme: string = "primary";

	constructor (private element: Element) {

	}

	@computedFrom(Reflection.getPropertyPath<CompPagination>(z => z.paginationMappings))
	private get mappings(): PagePaginationMappings {
		if (this.paginationMappings) {
			return this.paginationMappings;
		}
		
		const pageVm: IPaginationPage = (<any>this.element).au.controller.scope.bindingContext as IPaginationPage;

		if(!pageVm) {
			throw new Error("IPaginationPage must be used within a page component");
		}

		return this.paginationMappings = new PagePaginationMappings(pageVm);
	}

	@computedFrom(
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings),
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings.currentPage),
	)
	public get hasPrevious(): boolean {
		return this.mappings ? this.mappings.currentPage > 1 : false;
	}

	@computedFrom(
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings),
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings.currentPage),
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings.lastPage),
	)
	public get hasNext(): boolean {
		return this.mappings ? this.mappings.currentPage < this.mappings.lastPage : false;
	}

	@computedFrom(
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings),
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings.currentPage),
	)
	public get firstPage(): number {
		const minimum = 1, limit = 5, offset = Math.floor(limit / 2);

		if (!this.mappings) {
			return minimum;
		}

		if (this.mappings.currentPage - offset < minimum) {
			return minimum;
		}

		if (this.mappings.lastPage - limit < minimum) {
			return minimum;
		}

		if (this.mappings.currentPage + offset > this.mappings.lastPage) {
			return this.mappings.lastPage - limit + 1;
		}

		return this.mappings.currentPage - offset;
	}

	@computedFrom(
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings),
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings.currentPage),
		Reflection.getPropertyPath<CompPagination>(dgp => dgp.mappings.lastPage),
	)
	public get lastPage(): number {
		const minimum = 1, limit = 5, offset = Math.floor(limit / 2);

		if (!this.mappings) {
			return minimum;
		}

		if (this.mappings.lastPage - limit < 0) {
			return this.mappings.lastPage;
		}

		if (this.mappings.currentPage + offset > this.mappings.lastPage) {
			return this.mappings.lastPage;
		}

		if (this.mappings.currentPage + offset > limit - 1) {
			return this.mappings.currentPage + offset;
		}

		return limit;
	}

	public changePage(page: number): void {
		this.mappings.currentPage = page;
	}
}